module.exports = __webpack_public_path__ + "static/media/arrow_down_icon.99fe578b.svg";